import React from 'react';
import Spinner from './common/Spinner';

export default (props) => 
	<div
		className='loader-box'
		style={{display: props.condition?'block':'none', zIndex: "9999"}}>
		<Spinner/>
	</div>
